/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';

export class InitiativeGroupApi extends BaseApi {
  endPoint: string = '/api/admin/initiative-groups';
}
